outcomesPanelButton = {};

outcomesPanelButton.create = function (data) {
  var button = new PIXI.Container();

  button.FQN = data.FQN;
  button.direction = data.direction;
  button.allowFunction = data.direction === 'up' ? 'canScrollUp' : 'canScrollDown';
  button.doFunction = data.direction === 'up' ? 'scrollUp' : 'scrollDown';
  button._replayComplete = false;

  InputHelpers.addGenerics(button);
  InputHelpers.addAutoplayFlag(button);
  InputHelpers.addCanSpinFlag(button);

  button.canShow = function () {
    if (checkForUndefined(this.gameConfig)) return false;

    return true;
  };

  button.canEnable = function () {
    if (checkForUndefined(this.gameConfig)) return false;

    let allow = false;

    if (Reflex.replayGame === true) {
      allow = button._replayComplete && button.outcomesPanel[button.allowFunction]();
    } else {
      allow =
        button.outcomesPanel[button.allowFunction]() &&
        this._flags.canSpin &&
        !this._flags.autoplayStarted &&
        !this._flags.modal.active;
    }

    button.buttonContainer.alpha = allow ? 1 : 0.5;

    return allow;
  };

  button.onConfig = function (config) {
    this.gameConfig = config;
  };

  button.isAllowed = function () {
    return true;
  };

  button.setupResources = function () {
    let self = this;
    messageBus.subscribe('spinner:GameConfigEvent', function () {
      self.onLayoutComplete();
    });

    messageBus.subscribe('spinner:GameConfigEvent', button.onConfig.bind(button));

    if (Reflex.replayGame === true) {
      messageBus.subscribe('platform:ReplayComplete', () => {
        button.onReplayComplete();
      });
    }
  };

  button.onReplayComplete = function () {
    button._replayComplete = true;
  };

  button.onLayoutComplete = function () {
    button.outcomesPanel = resourceManager.get('outcomesPanel:OutcomesPanel');
    button.buttonContainer = resourceManager.get(button.FQN);
  };

  button.setRecovery = function () {};

  button.onPressedCallback = function () {
    button.outcomesPanel[button.doFunction]();
  };

  return button;
};

outcomesPanelButton.initialise = function (json, object) {
  object.setupResources();
};

outcomesPanelButton.getFilesRequired = function () {
  return [];
};

resourceManager.registerObjectType(
  'outcomesPanelButton',
  outcomesPanelButton.create,
  outcomesPanelButton.initialise,
  outcomesPanelButton.getFilesRequired
);
